export class Semaphore {
	constructor(maxConcurrency = 1) {
		if(!Number.isInteger(maxConcurrency) || maxConcurrency < 1) {
			throw new Error("Semaphore requires a positive concurrency limit.");
		}

		this.maxConcurrency = maxConcurrency;
		this.activeCount = 0;
		this.queue = [];
	}

	async run(task) {
		await this.acquire();

		try {
			return await task();
		}
		finally {
			this.release();
		}
	}

	acquire() {
		if(this.activeCount < this.maxConcurrency) {
			this.activeCount++;
			return Promise.resolve();
		}

		return new Promise(resolve => {
			this.queue.push(resolve);
		});
	}

	release() {
		const next = this.queue.shift();
		if(next !== undefined) {
			next();
			return;
		}

		this.activeCount--;
	}
}

export const createSemaphore = (maxConcurrency) => new Semaphore(maxConcurrency);
